import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpResponse } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";

@Injectable({ providedIn: "root" })
export class AsignacionService {
  constructor(private http: HttpClient) {}

  public get(): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.serverUrl}api/settings/unidades/get`
    );
  }

  public asignar(defa: any): Observable<any> {
    const options = {
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
    };
    return this.http.post<any>(
      `${environment.serverUrl}api/settings/unidades/asignar`,
      defa,
      options
    );
  }

  public desasignar(defa: any): Observable<any> {
    const options = {
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
    };
    return this.http.post<any>(
      `${environment.serverUrl}api/settings/unidades/desasignar`,
      defa,
      options
    );
  }

  public getHistorial(id: string): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.serverUrl}api/settings/unidades/get/asignacion?i=${id}`
    );
  }
  public getCarta(i: string): Observable<HttpResponse<Blob>> {
    return this.http.get(
      `${environment.serverUrl}api/settings/unidades/get/asignacion/file`,
      { params: { i }, responseType: "blob", observe: "response" }
    );
  }

  public getCombosModal(): Observable<{
    Supervisores: any[];
    Choferes: any[];
  }> {
    return this.http.get<{
      Supervisores: any[];
      Choferes: any[];
    }>(
      `${environment.serverUrl}api/settings/unidades/get/asignacion/getCombos`
    );
  }
}
